<template>
  <div class="lock-chart-wrapper">
    <EmptyRadarChart :dimension="dimension" />
    <div class="lock-chart-wrapper__slot-wrapper">
      <slot />
    </div>
  </div>
</template>

<script>
import EmptyRadarChart from '@/components/charts/EmptyRadarChart.vue'
export default {
  components: {
    EmptyRadarChart
  },
  props: {
    dimension: {
      type: [String, Number],
      default: null
    },
  }
}
</script>

<style lang="scss" scoped>
.lock-chart-wrapper {
  position: relative;
  &__slot-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>